import { FormMixin } from "stylemix-base";
import isPlainObject from "lodash-es/isPlainObject";

export default {
  mixins: [FormMixin],

  props: {
    id: {},
  },

  data() {
    return {
      model: {},
    };
  },

  computed: {
    updating() {
      return !!this.id;
    },
  },

  methods: {
    loadForm(Proxy) {
      let promise;

      if (this.updating) {
        promise = new Proxy().edit(this.id);
      } else {
        promise = new Proxy().create();
      }

      return promise.then((result) => {
        this.model = isPlainObject(result.data) ? result.data : {};
        this.setFields(result.fields);
        return result;
      });
    },

    save(Proxy) {
      const formData = this.formData(this.model);
      let promise;

      if (this.updating) {
        promise = new Proxy().update(this.id, formData);
      } else {
        promise = new Proxy().store(formData);
      }

      return promise
        .then((result) => {
          this.onSaved(result);
          return result;
        })
        .catch((response) => {
          this.onSaveError(response);
          return Promise.reject(response);
        });
    },

    onSaved(result) {
      this.$emit("saved", result);
    },

    onSaveError(response) {
      if (response.status === 422) {
        this.setValidationErrors(response.data.errors);
        this.$emit("invalid", response.data);
        this.$toast.error(response.data.message);
      }
    },

    cancel() {
      this.$emit("cancelled");
    },
  },
};
